export const CONTACT_ADDRESS_TYPES = [
    "Unknown",
    "Other",
    "Home",
    "Work",
    "Billing",
    "Shipping",
    "Headquarters",
    "Branch",
];
